module.exports = __webpack_public_path__ + "NL-new-logo-ccd1a854d8c1bbd27864.svg";